import { Breadcrumbs, Button, Card, CardActions, CardContent, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, InputLabel, makeStyles, MenuItem, Select, Typography } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import { Alert, AlertTitle } from '@material-ui/lab';
import axios from 'axios';
import { Form, useFormikContext } from 'formik';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { Link } from "react-router-dom";
import { AppInput } from '../../components/atoms/inputs/AppInput';
import { LoadingButton } from '../../components/atoms/inputs/LodingButton';
import { useStore } from '../../store';
import { ApiResponse } from '../../types';

const useStyles = makeStyles((theme) => ({
    controlPaper: {
        width: "100%",
        padding: "8px",
    },
    link: {
        display: 'flex',
        textDecoration: 'none',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    taxRegime: {
        marginBottom: 30
    },
}))

export default function OptTaxRegimeFormComponent() {
    const { enqueueSnackbar } = useSnackbar();
    const classes = useStyles();
    const store = useStore();

    const { values, handleChange, isSubmitting, setSubmitting, setFieldValue, resetForm, setFieldTouched, setFieldError } = useFormikContext<any>();

    const [confiirmationAlertOpen, setConfiirmationAlertOpen] = useState(false);

    function getCurrentFinancialYear() {
        var fiscalyear = "";
        var today = new Date();
        if ((today.getMonth() + 1) <= 3) {
            fiscalyear += today.getFullYear() - 1;
        } else {
            fiscalyear += today.getFullYear();
        }
        return fiscalyear
    }

    const handleConfirmationPopupClose = () => {
        setConfiirmationAlertOpen(false);
    }

    const handleConfirmationOpen = () => {
        if (!values.erpId || !values.erpId.match(/^\d{8}$|^[\d\/]{11}$/)) { //TODO Rectify Regex for legecy PPO
            setFieldValue('message', { type: 'error', text: "Valid PPO Number Required (বৈধ পিপিও নম্বর প্রয়োজনীয়)" })
            enqueueSnackbar("Valid PPO Number Required (বৈধ পিপিও নম্বর প্রয়োজনীয়)", { variant: 'error' });
            return;
        }
        else if (!values.taxRegime || values.taxRegime == 'NA') {
            enqueueSnackbar("Please select tax regime (অনুগ্রহ করে করব্যবস্থা নির্বাচন করুন)", { variant: 'error' });
            return;
        }
        setConfiirmationAlertOpen(true);
    }

    const handleSubmit = async () => {
        setSubmitting(true)
        handleConfirmationPopupClose();
        setFieldValue('message', null)
        axios.get<ApiResponse<{}>>(`${process.env.REACT_APP_NEW_API_ROOT}WBSEDCLERPPENSIONEROPTTAXREGIMEWS/UpdateTaxRegime`, {
            params: {
                taxRegimeDetails: {
                    EMP_ID: values.erpId,
                    START_DAT: values.endDate,
                    //START_DAT: new Date().getFullYear() + '0301',
                    //END_DAT: values.endDate,
                    TAX_OPTION: values.taxRegime
                }
            },
            headers: {
                'Content-Type': 'application/json',
            }
        })
            // axios.get<ApiResponse<{}>>(`${process.env.REACT_APP_NEW_API_ROOT}WBSEDCLERPPENSIONEROPTTAXREGIMEWS/UpdateTaxRegime`, {
            //     params: {
            //         taxRegimeDetails: {
            //             EMP_ID: values.erpId,
            //             START_DAT: new Date().getFullYear() + '0301',
            //             // END_DAT: '20240228',
            //             TAX_OPTION: values.taxRegime
            //         }
            //     },
            //     headers: {
            //         'Content-Type': 'application/json',
            //     }
            // })
            .then(
                ({ data: resp, status: status }) => {
                    //console.log(resp);
                    console.log(values.erpId, values.endDate, values.taxRegime);
                    console.log(resp);
                    if (status === 200) {
                        // resetForm();

                        let user: any = resp;
                        setSubmitting(false);
                        // user.applStatus = 'PENDING';
                        if (user?.result == 'S') {
                            setFieldValue('rejectReason', '')
                            setFieldValue('message', { type: 'success', text: "You have successfully selected tax regime (আপনি সফলভাবে করব্যবস্থা নির্বাচন করেছেন)" })
                            enqueueSnackbar("You have successfully selected tax regime (আপনি সফলভাবে করব্যবস্থা নির্বাচন করেছেন)", { variant: 'success' });
                        }
                        else if (user?.result == 'X') {
                            setFieldValue('rejectReason', user?.REJECTION_REASON ?? '')
                            setFieldValue('message', { type: 'error', text: "Something went wrong. Please try again later (কিছু ভুল হয়েছে। কিছুক্ষণ পরে আবার চেষ্টা করুন)" })
                            enqueueSnackbar("Something went wrong. Please try again later (কিছু ভুল হয়েছে। কিছুক্ষণ পরে আবার চেষ্টা করুন)", { variant: 'error' });
                        }
                        else if (user?.result == 'A') {
                            setFieldValue('rejectReason', user?.REJECTION_REASON ?? '')
                            setFieldValue('message', { type: 'error', text: "Option has already been excercised for this financial year (বিকল্পটি ইতিমধ্যে এই আর্থিক বছরের জন্য ব্যবহার করা হয়েছে)" })
                            enqueueSnackbar("Option has already been excercised for this financial year (বিকল্পটি ইতিমধ্যে এই আর্থিক বছরের জন্য ব্যবহার করা হয়েছে)", { variant: 'error' });
                        }
                        else if (user?.result == 'N') {
                            setFieldValue('rejectReason', user?.REJECTION_REASON ?? '')
                            setFieldValue('message', { type: 'error', text: "Something went wrong. Please try again later (কিছু ভুল হয়েছে। কিছুক্ষণ পরে আবার চেষ্টা করুন)" })
                            enqueueSnackbar("Something went wrong. Please try again later (কিছু ভুল হয়েছে। কিছুক্ষণ পরে আবার চেষ্টা করুন)", { variant: 'error' });
                        }
                        else if (user?.result == 'I') {
                            setFieldValue('rejectReason', user?.REJECTION_REASON ?? '')
                            setFieldValue('message', { type: 'error', text: "Something went wrong. Please try again later (কিছু ভুল হয়েছে। কিছুক্ষণ পরে আবার চেষ্টা করুন)" })
                            enqueueSnackbar("Something went wrong. Please try again later (কিছু ভুল হয়েছে। কিছুক্ষণ পরে আবার চেষ্টা করুন)", { variant: 'error' });
                        }
                        else {
                            setFieldValue('rejectReason', '')
                            setFieldValue('message', { type: 'error', text: "Something went wrong. Please try again later (কিছু ভুল হয়েছে। কিছুক্ষণ পরে আবার চেষ্টা করুন)" })
                            enqueueSnackbar("Something went wrong. Please try again later (কিছু ভুল হয়েছে। কিছুক্ষণ পরে আবার চেষ্টা করুন)", { variant: 'error' })
                        }
                    }
                    else {
                        setFieldValue('rejectReason', '')
                        setFieldValue('message', { type: 'error', text: "Something went wrong. Please try again later (কিছু ভুল হয়েছে। কিছুক্ষণ পরে আবার চেষ্টা করুন)" })
                        enqueueSnackbar("Something went wrong. Please try again later (কিছু ভুল হয়েছে। কিছুক্ষণ পরে আবার চেষ্টা করুন)", { variant: 'error' })
                    }
                },
            )
            .catch((e) => {
                setFieldValue('message', { type: 'error', text: "Network error" })
                enqueueSnackbar('Network error', { variant: 'error' })
                setSubmitting(false)
            })
    }

    return (
        <Form>
            <Grid item>
                <Card className={classes.controlPaper}>
                    <CardContent>
                        <Grid container
                            spacing={3}
                            direction="column"
                            justify="space-around"
                            alignItems="stretch">

                            <Grid item>
                                <Breadcrumbs>
                                    <Link to="/" className={classes.link}>
                                        <Typography gutterBottom variant="h5" component="h2">
                                            <HomeIcon className={classes.icon} />Home</Typography>
                                    </Link>
                                    <Typography gutterBottom variant="h5" component="h2">Opt Tax Regime (করব্যবস্থা বেছে নিন)</Typography>
                                </Breadcrumbs>
                            </Grid>

                            {
                                values.message &&
                                <Grid item>
                                    <Alert severity={values.message.type}>
                                        <AlertTitle>
                                            {values.message.type === "success" ? "Success" : values.message.type === "warning" ? "Pending" : values.message.type === "info" ? "Not Applied" : (values.message.type === "error" && values.message.text == 'Your application is rejected') ? "Rejected" : "Error(ত্রুটি)"}
                                        </AlertTitle>
                                        {values?.rejectReason ? values.rejectReason : values.message.text}
                                    </Alert>
                                </Grid>
                            }
                            <Grid item>
                                <FormControl variant="filled" fullWidth>
                                    <AppInput disabled fullWidth={true} name="erpId" label={values.erpId.startsWith("800") ? "PPO No" : "FPPO No"} />
                                </FormControl>
                            </Grid>

                            <Grid item>
                                <FormControl variant="filled" fullWidth>
                                    <AppInput disabled fullWidth={true} name="nameOfPensioner" label={values.erpId.startsWith("800") ? "Name of pensioner" : "Name of Family pensioner"} />
                                </FormControl>
                            </Grid>

                            <Grid item>
                                <Alert severity={'info'} style={{ textAlign: "justify" }}>
                                    <AlertTitle>
                                        Your default Tax Regime  is New. To Change, select your option. Option will be final and cannot be changed further within this financial year.
                                    </AlertTitle>
                                </Alert>
                            </Grid>

                            <Grid item>
                                <FormControl variant="filled" fullWidth>
                                    <InputLabel id="demo-simple-select-filled-label">Tax Regime to be opted</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-filled-label"
                                        id="demo-simple-select-filled"
                                        name="taxRegime"
                                        className={classes.taxRegime}
                                        value={values.taxRegime}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value={"NA"}>Select Tax Regime</MenuItem>
                                        <MenuItem value={"1"}>Old Tax Regime</MenuItem>
                                        <MenuItem value={"2"}>New Tax Regime</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item>
                                <Alert severity={"info"} icon={false}>
                                    <AlertTitle>Tax option date from
                                    </AlertTitle>01-03-{new Date().getFullYear()} to 28-02-{new Date().getFullYear() + 1}
                                </Alert>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <CardActions>
                        <LoadingButton
                            // type="submit"
                            color="primary"
                            variant="contained"
                            size="large"
                            loading={isSubmitting}
                            onClick={() => { handleConfirmationOpen() }}>
                            Opt Tax Regime (করব্যবস্থা বেছে নিন)
                        </LoadingButton>

                        <Link to="/" className={classes.link}>
                            <Button variant='contained' color='primary' size='large'>
                                Back (পিছনে)
                            </Button>
                        </Link>

                    </CardActions>
                </Card>
            </Grid>
            <Dialog
                open={confiirmationAlertOpen}
                onClose={handleConfirmationPopupClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Alert (সতর্কতা)"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Option will be final and cannot be changed further within this financial year. Do you want to proceed? (বিকল্প চূড়ান্ত হবে এই আর্থিক বছরের মধ্যে আর পরিবর্তন করা যাবে না। আপনি কি এগিয়ে যেতে চান?)
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmationPopupClose} color="primary">
                        No (না)
                    </Button>
                    <Button onClick={handleSubmit} color="primary" autoFocus>
                        Yes (হ্যাঁ)
                    </Button>
                </DialogActions>
            </Dialog>
        </Form>
    )
}